import React from "react";
import { FaRegCheckCircle } from "react-icons/fa";

export const Banner = () => {
  const ban1 = require("../../images/ban1.jpg");

  // const ban2 =
  //   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTyljBFbc6MpmL3MamAjt9NQpAHsdfnvxTG8g&usqp=CAU";

  // const ban3 =
  //   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcT48JV4ceVTZOBBAfa2VWeZPh78KM0dyQ9p5eHirv_N4tRqDmmdkE9dfrJ-fH_DY2v6WQ&usqp=CAU";

  return (
    <>
      <section
        className="my-3"
        style={{ backgroundColor: "#0d084d", color: "white" }}
      >
        <br />
        <br />

        <div className="container-fluid ">
          <div className="mt-5">
            <div className="row ">
              <div className="col-md-1"></div>
              <div className="col-md-5 mt-2">
                <div className="">
                  <h3 className="fw-bolder text-white">
                    A whole world of Business talent at your fingertips
                  </h3>
                  <ul className="text-white">
                    <li>
                      <h5>
                        <FaRegCheckCircle />
                        &nbsp; Lorem ipsum dolor sit amet consectetur,
                      </h5>
                      <p className="t-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Dolorum libero exercitationem nam numquam reiciendis hic
                        eligendi, obcaecati delectus laudantium quisquam nostrum
                        dignissimos architecto fuga eius voluptates enim illo
                        natus aperiam?
                      </p>
                    </li>
                    <li>
                      <h5>
                        <FaRegCheckCircle />
                        &nbsp; Lorem ipsum dolor sit amet consectetur,
                      </h5>
                      <p className="t-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Dolorum libero exercitationem nam numquam reiciendis hic
                        eligendi, obcaecati delectus laudantium quisquam nostrum
                        dignissimos architecto fuga eius voluptates enim illo
                        natus aperiam?
                      </p>
                    </li>
                    <li>
                      <h5>
                        <FaRegCheckCircle />
                        &nbsp; Lorem ipsum dolor sit amet consectetur,
                      </h5>
                      <p className="t-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Dolorum libero exercitationem nam numquam reiciendis hic
                        eligendi, obcaecati delectus laudantium quisquam nostrum
                        dignissimos architecto fuga eius voluptates enim illo
                        natus aperiam?
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-5">
                <br />
                <br />
                <br />
                <br />
                <div className="mt-5">
                  <img
                    src={ban1}
                    alt=""
                    width={"100%"}
                    className="img-thumbnail"
                    style={{ height: "20rem", width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </section>
      {/* <section
        className="my-3"
        style={{ backgroundColor: "#000", color: "white" }}
      >
        <br />
        <br />
        <div className="container-fluid ">
          <div className="mt-5">
            <div className="row ">
              <div className="col-md-1"></div>
              <div className="col-md-5">
                <br />
                <br />
                <br />
                <br />
                <div className="mt-5">
                  <img
                    src={ban2}
                    alt=""
                    width={"100%"}
                    className="img-thumbnail"
                    style={{ height: "20rem", width: "100%" }}
                  />
                </div>
              </div>
              <div className="col-md-5 mt-2">
                <div className="">
                  <h3 className="fw-bolder text-white">
                    A WHOLE WORLD OF BUSINESS TALENT AT YOUR FINGERTIPS
                  </h3>
                  <ul className="text-white">
                    <li>
                      <h5>
                        <FaRegCheckCircle />
                        &nbsp; Lorem ipsum dolor sit amet consectetur,
                      </h5>
                      <p className="t-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Dolorum libero exercitationem nam numquam reiciendis hic
                        eligendi, obcaecati delectus laudantium quisquam nostrum
                        dignissimos architecto fuga eius voluptates enim illo
                        natus aperiam?
                      </p>
                    </li>
                    <li>
                      <h5>
                        <FaRegCheckCircle />
                        &nbsp; Lorem ipsum dolor sit amet consectetur,
                      </h5>
                      <p className="t-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Dolorum libero exercitationem nam numquam reiciendis hic
                        eligendi, obcaecati delectus laudantium quisquam nostrum
                        dignissimos architecto fuga eius voluptates enim illo
                        natus aperiam?
                      </p>
                    </li>
                    <li>
                      <h5>
                        <FaRegCheckCircle />
                        &nbsp; Lorem ipsum dolor sit amet consectetur,
                      </h5>
                      <p className="t-body">
                        Lorem ipsum dolor sit amet consectetur adipisicing elit.
                        Dolorum libero exercitationem nam numquam reiciendis hic
                        eligendi, obcaecati delectus laudantium quisquam nostrum
                        dignissimos architecto fuga eius voluptates enim illo
                        natus aperiam?
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="col-md-1"></div>
            </div>
          </div>
        </div>
        <br />
        <br />
      </section> */}
    </>
  );
};
export default Banner;
